export function formatPassedQuantity(passed: number, total: number) {
  return `(${passed} / ${total})`
}
